import { COMMON_QUERY_PARAMS } from '@/constants/debug';
import { FPageNameEnum } from '@/types/pages';
const buildExperienceHref = (id) => `/${FPageNameEnum.experience}/${id}${COMMON_QUERY_PARAMS}`;
export default buildExperienceHref;
